import * as go from 'gojs';
import { getImageFeed } from 'unitData/Feed/getImageFeed';
import { getIOPort, getImageBinding, makeNode } from '../../utils';

export const FeedTemplate = makeNode(getImageBinding('feedImg', getImageFeed), [
  getIOPort(go.Spot.Bottom, 'output'),
  getIOPort(go.Spot.Top, 'input'),
]);

export default FeedTemplate;
